import { supabase } from '@/integrations/supabase/client';

/**
 * Archives an order by updating its status to 'archived'
 */
export const archiveOrder = async (orderId: string): Promise<{ success: boolean; error?: string }> => {
  try {
    console.log('📦 Archiving order:', orderId);
    
    const { data, error } = await supabase
      .from('orders')
      .update({ 
        status: 'archived',
        updated_at: new Date().toISOString()
      })
      .eq('id', orderId);

    if (error) {
      console.error('❌ Error archiving order:', error);
      return { success: false, error: error.message };
    }

    console.log('✅ Order archived successfully:', orderId);
    return { success: true };
  } catch (error) {
    console.error('❌ Failed to archive order:', error);
    return { success: false, error: 'Failed to archive order' };
  }
};

/**
 * Archives multiple orders at once
 */
export const archiveMultipleOrders = async (orderIds: string[]): Promise<{ success: boolean; error?: string }> => {
  try {
    console.log('📦 Archiving multiple orders:', orderIds);
    
    const { data, error } = await supabase
      .from('orders')
      .update({ 
        status: 'archived',
        updated_at: new Date().toISOString()
      })
      .in('id', orderIds);

    if (error) {
      console.error('❌ Error archiving orders:', error);
      return { success: false, error: error.message };
    }

    console.log('✅ Orders archived successfully:', orderIds.length);
    return { success: true };
  } catch (error) {
    console.error('❌ Failed to archive orders:', error);
    return { success: false, error: 'Failed to archive orders' };
  }
};